import {
  LITTER_USEFUL_LINKS_ADD,
  LITTER_USEFUL_LINKS_FETCH,
  LITTER_USEFUL_LINKS_UPDATE,
  LITTER_USEFUL_LINKS_DELETE,
  AUTH_LOG_OUT_USER,
} from "actions/types";
import { AUTH_LOG_OUT_PROVIDER } from "containers/auth/Pet_Services_Portal/actions";
import _ from "lodash";

const INITIAL_STATE = {
  entries: [],
  fetched: false,
};

export default function LitterUsefulLinksReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case LITTER_USEFUL_LINKS_FETCH:
      return {
        ...state,
        entries: _.uniqWith([...state.entries, ...action.payload], _.isEqual),
        fetched: true,
      };
    case LITTER_USEFUL_LINKS_ADD:
      return {
        ...state,
        entries: _.sortBy(
          [...state.entries, action.payload],
          "dateCreated"
        ).reverse(),
      };
    case LITTER_USEFUL_LINKS_UPDATE:
      return {
        ...state,
        entries: _.sortBy(
          [
            ...state.entries.filter(
              (entry) => entry._id !== action.payload._id
            ),
            action.payload,
          ],
          "dateCreated"
        ).reverse(),
      };
    case LITTER_USEFUL_LINKS_DELETE:
      return {
        ...state,
        entries: state.entries.filter((entry) => entry._id !== action.payload),
      };
    case AUTH_LOG_OUT_USER:
    case AUTH_LOG_OUT_PROVIDER:
      return INITIAL_STATE;
    default:
      return state;
  }
}
